import { Form, Formik } from 'formik'
import React from 'react'
import FormikControl from './FormikControl'

function FormContainer({ fields }) {

    const initialValues = {};
    const handleSubmit = values => {
        
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            enableReinitialize
            >
            {
                (formik) => {
                    return (
                        <Form>
                            {fields.map(field => field.name && <FormikControl type={field.key} field={field} />)}

                            {/* <button type='submit'>Submit</button> */}
                        </Form>
                    )

                }
            }
        </Formik>
    )
}

export default FormContainer